const steps = [
  {
    number: '01',
    icon: 'ri-edit-2-line',
    title: 'Enter Your Business & Campaign Details',
    description: 'Tell AdForge your business name, industry, target audience, and the offer you\'re promoting. Choose a campaign goal, ad angle, and optionally describe the creative scene you want.',
    detail: 'Business profile · Ad platform · Offer · Goal · Tone · Ad angle',
    image: 'https://readdy.ai/api/search-image?query=elegant%20overhead%20flat%20lay%20of%20a%20minimal%20modern%20workspace%20with%20an%20open%20laptop%20showing%20a%20warm%20glowing%20screen%20a%20small%20potted%20plant%20a%20ceramic%20coffee%20mug%20and%20clean%20white%20marble%20desk%20surface%20warm%20amber%20side%20lighting%20commercial%20photography%20ultra%20sharp%20depth%20of%20field&width=500&height=380&seq=how-it-works-step-01c&orientation=landscape',
  },
  {
    number: '02',
    icon: 'ri-cpu-line',
    title: 'AI Writes Copy & Generates Creative Images',
    description: 'AdForge produces multiple hooks, headlines, body copy, and CTAs — and generates real AI creative images for your ad, all formatted for your chosen platform in under 30 seconds.',
    detail: 'Hooks · Headlines · Body copy · CTAs · AI creative images',
    image: 'https://readdy.ai/api/search-image?query=futuristic%20AI%20brain%20neural%20network%20processing%20data%20with%20glowing%20orange%20amber%20light%20streams%20on%20dark%20background%20concept%20art%20minimal%20tech%20design&width=500&height=380&seq=how-it-works-step-02&orientation=landscape',
  },
  {
    number: '03',
    icon: 'ri-rocket-2-line',
    title: 'Edit, Refine & Launch',
    description: 'Open any ad in the built-in Visual Editor to move elements, edit text, customize buttons, and tweak animations. Or copy with one click and paste straight into your ad platform.',
    detail: 'Visual editor · One-click copy · Regenerate images · Download',
    image: 'https://readdy.ai/api/search-image?query=successful%20business%20person%20launching%20digital%20ad%20campaign%20on%20computer%20screen%20with%20colorful%20analytics%20dashboard%20warm%20modern%20office%20professional%20setting&width=500&height=380&seq=how-it-works-step-03&orientation=landscape',
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-semibold text-orange-500 uppercase tracking-widest mb-3">The Process</span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-stone-900 mb-4">
            From idea to live ad
            <br />
            <span className="text-orange-500">in 3 simple steps</span>
          </h2>
          <p className="text-lg text-stone-500 max-w-xl mx-auto">
            No copywriting experience needed. AdForge does the heavy lifting so you can focus on running your business.
          </p>
        </div>

        <div className="flex flex-col gap-16">
          {steps.map((step, index) => (
            <div
              key={step.number}
              className={`flex flex-col ${index % 2 === 1 ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-12`}
            >
              <div className="flex-1 lg:max-w-lg">
                <div className="inline-flex items-center gap-3 mb-6">
                  <span className="text-6xl font-black text-orange-100 leading-none">{step.number}</span>
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-orange-50 text-orange-500">
                    <i className={`${step.icon} text-xl`} />
                  </div>
                </div>
                <h3 className="text-2xl md:text-3xl font-extrabold text-stone-900 mb-4">{step.title}</h3>
                <p className="text-stone-500 text-base leading-relaxed mb-5">{step.description}</p>
                <div className="flex flex-wrap gap-2">
                  {step.detail.split(' · ').map((tag) => (
                    <span key={tag} className="text-xs font-medium bg-orange-50 text-orange-600 px-3 py-1.5 rounded-full border border-orange-100">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
              <div className="flex-1 w-full">
                <div className="w-full h-72 lg:h-80 rounded-2xl overflow-hidden border border-stone-100">
                  <img
                    src={step.image}
                    alt={step.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
